// themeService/darkTheme.ts
import { createTheme } from '@mui/material/styles'

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#121212',
      paper: '#1e1e1e'
    },
    primary: {
      main: '#e1e0e1'
    },
    secondary: {
      main: '#648dfe'
    }
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e1e1e',
          color: '#ffffff',
          border: '1px solid #333',
          '&.Mui-expanded': {
            margin: 'auto'
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: '#2c2c2c',
          color: '#ffffff',
          '&.Mui-expanded': {
            minHeight: '48px'
          }
        },
        content: {
          '&.Mui-expanded': {
            margin: '12px 0'
          }
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a1a1a',
          color: '#dcdcdc',
          padding: '16px'
        }
      }
    }
  }
})

export default darkTheme
